import script from "./HomeGuideBlockRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeGuideBlockRenderer.vue?vue&type=script&setup=true&lang=js"

import "./HomeGuideBlockRenderer.vue?vue&type=style&index=0&id=9a37ca04&scoped=true&lang=css"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a37ca04"]])

export default __exports__